import React, { useMemo, useState } from "react"

import { formatDate } from "../../../../../Pages/Data/Visualize/DataReview/utils"
import { useEEGCalibration } from "../../../../../Pages/Data/Visualize/DataReview/Calibration/hooks"
import { EEGCalibrationStatus } from "../../../../../Pages/Data/Visualize/DataReview/Calibration/types"

import { CalibrationStatusDetails } from "./CalibrationStatusBanner"
import { CalibrationModal } from "./CalibrationModal"
import { StatusModal } from "./StatusModal"

export const EEGCalibrationModal: React.FC = () => {
	const { status, record, pxPerMm, save, clear } = useEEGCalibration()
	const [mode, setMode] = useState<"status" | "calibration">(
		status === EEGCalibrationStatus.VALID ? "status" : "calibration",
	)

	const details: CalibrationStatusDetails = useMemo(() => {
		switch (status) {
			case EEGCalibrationStatus.VALID: {
				const segments: string[] = []
				record?.pxPerMm && segments.push(`${record.pxPerMm.toFixed(3)} px/mm`)
				record?.savedAt && segments.push(formatDate(new Date(record.savedAt)))
				const summary = segments.join(" • ")

				return {
					state: "success",
					title: "Display is calibrated.",
					desc: summary,
				}
			}
			case EEGCalibrationStatus.OUTDATED:
				return {
					state: "warning",
					title: "Display parameters changed",
					desc: "Display resolution changed. Recalibrate to restore accurate scaling.",
				}
			case EEGCalibrationStatus.MISSING:
				return {
					state: "warning",
					title: "Not calibrated",
					desc: "Measurements fall back to default px/mm estimates.",
				}
		}
	}, [record, status])

	return mode === "calibration" ? (
		<CalibrationModal
			details={details}
			status={status}
			record={record}
			save={save}
			clear={clear}
		/>
	) : (
		<StatusModal pxPerMm={pxPerMm} details={details} setMode={setMode} />
	)
}
